import { apiConfig } from "./apiConfig";

const submitUrl = apiConfig.oftheday.submit;

export const postSubmit = (axios, payload) => axios.post(`${submitUrl}`, payload);
export const editPostSubmit = (axios, payload) => axios.put(`${submitUrl}`, payload);
export const deletePost = (axios, id, payload) => axios.delete(`${apiConfig.oftheday.delete}/${id}`, { data: payload });
